export const formatNumberWithSpaces = (
  num?: number | string | null,
): string => {
  if (!num) {
    return "-";
  }

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
